import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvironmentHeaderComponent } from './environment-header.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RedirectionDialogModule } from 'src/app/components/redirection-dialog/redirection-dialog.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';


@NgModule({
  declarations: [
    EnvironmentHeaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
    IconsModule,
    RouterModule,
    MatMenuModule,
    MatDividerModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    RedirectionDialogModule,
    MatProgressBarModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    EnvironmentHeaderComponent
  ]
})
export class EnvironmentHeaderModule { }
